// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Close: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M18.4 16.5L32.2 2.8c.2-.2.3-.4.3-.7s-.1-.5-.3-.7l-.5-.5c-.4-.4-1-.4-1.4 0L16.5 14.6 2.8.8c-.4-.4-1-.4-1.4 0l-.6.5c-.1.2-.2.5-.2.8 0 .3.1.5.3.7l13.7 13.7L.8 30.2c-.2.2-.3.4-.3.7 0 .3.1.5.3.7l.5.5c.4.4 1 .4 1.4 0l13.7-13.7 13.7 13.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3l.5-.5c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7L18.4 16.5z"/></svg>;
};

export default React.memo(Close);
